<div class="modal-header">
    <h5 class="modal-title pull-left">Onboard Unregistered Vendor</h5>
    <i class="fa fa-times-circle fa-2x" aria-hidden="true" (click)="bsModalRef?.hide()"></i>
</div>
<div class="modal-body">
    <section class="prInitiator">
        <div class="d-flex flex-column mb-4 mt-1">
            <ng-container>
                <form [formGroup]="statusForm" class="p-4">
                    <div class="row">
                        <div class="col-4">
                            <label for="rfq_template_id" class="form-label text-small">Rfq Template Id</label>
                            <input type="text" name="rfq_template_id" [value]="rfq_template_id" readonly
                            class="form-control">
                        </div>
                        <div class="col-4">
                            <label for="vendor_code" class="form-label text-small">Vendor Code</label>
                            <input type="text" name="vendor_code" [(ngModel)]="vendor_code" class="form-control" [error]="statusForm.get('vendor_code')">
                            <form-feedback [formGroup]="statusForm" field="vendor_code"></form-feedback>
                        </div>
                        <div class="col-4">
                            <label for="puchase_org" class="form-label text-small">Purchase Organization</label>
                            <input type="text" name="puchase_org" [(ngModel)]="puchase_org" class="form-control" [error]="statusForm.get('puchase_org')">
                            <form-feedback [formGroup]="statusForm" field="puchase_org"></form-feedback>
                        </div>
                    </div>
                </form>
            </ng-container>
        </div>
    </section>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary me-2" (click)="submit()"
        [disabled]="!statusForm.valid">
        Submit
    </button>
</div>
